module.exports = __webpack_public_path__ + "media/images/emblems/Fullywappen-f286459c3474d0f7d7367a5af21abce3.png";